import React, { useContext } from "react";
import {
  Card,
  Container,
  Content,
  Title,
  SubTitle,
  LinkStyled,
  Header,
  LinkSubscribe,
} from "./styles";

import { CompetitionContext } from "contexts/CompetitionContext";
import { toReadableStageDate } from "helpers";

export default function ExplanatoryCards() {
  const { currentCompetition, currentCompetitionOpened } =
    useContext(CompetitionContext);

  // La tarjeta de postulación sólo aparece mientras la competición vigente está
  // abierta (entre la fecha de postulación y la del comité de selección).
  const closingDate =
    currentCompetition && toReadableStageDate(currentCompetition.selectionStage);

  return (
    <Container>
      <Content columns={currentCompetitionOpened ? 3 : 2}>
        <Card>
          <Header>
            <Title>Temáticas y Premios</Title>
            <SubTitle>Conocé las temáticas y premios de la competencia</SubTitle>
          </Header>
          <LinkStyled to="/tematicas">Ver más</LinkStyled>
        </Card>
        <Card>
          <Header>
            <Title>Reglamento</Title>
            <SubTitle>Conocé las bases y condiciones de la competencia</SubTitle>
          </Header>
          <LinkStyled to="/reglamento">Ver más</LinkStyled>
        </Card>
        {currentCompetitionOpened && (
          <Card>
            <Header>
              <Title>Postularse</Title>
              <SubTitle>
                {closingDate
                  ? `Cierre de postulaciones ${closingDate}`
                  : "Postulaciones abiertas"}
              </SubTitle>
            </Header>
            <LinkSubscribe to="/postularse">Inscribirse</LinkSubscribe>
          </Card>
        )}
      </Content>
    </Container>
  );
}
